'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RadioButtonGroup = require('material-ui/RadioButton/RadioButtonGroup');

var _RadioButtonGroup2 = _interopRequireDefault(_RadioButtonGroup);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WMRadioButtonGroup = function WMRadioButtonGroup(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(
			_RadioButtonGroup2.default,
			{
				defaultSelected: props.defaultSelected,
				name: props.name,
				onChange: props.onChange,
				valueSelected: props.valueSelected
			},
			props.children
		)
	);
};

exports.default = WMRadioButtonGroup;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMRadioButtonGroup/index.js